import axios from 'axios';
import qs from 'qs';

export default (isHQ) => {
  let queryData = {platform: isHQ ? 'HQ' : 'IRS', isRead: 0, start: 0, size: 3};
  return axios.post('/irs-api/ces-web/user/api/v3/message/totalList', qs.stringify(queryData)).then((res) => {
    global.vm.$emit('refresh_message', res.data);
  });
};



// WEBPACK FOOTER //
// ./src/components/util/getUnreadMessageInfo.js